import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AccountsService } from 'src/app/services/user-account/accounts.service';
import { TokenService } from '../../../../api/api-nmviajes/services/token.service';
import { DestinyService } from '../../../../services/destiny/destiny.service';
import { DataLayerService } from '../../../../services/analytics';
import { ToolbarService } from '../../../../services/toolbar';
import { VerifiedUserComponent } from '../../components';
import { HomeService } from '../../services/home.service';
import { isPlatformBrowser } from '@angular/common';
import { TabIndex } from '../../constants';
import { ConfigCatService } from '../../../../services/labs';

@Component({
  selector: 'app-home',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition('void => *', [style({ opacity: 0 }), animate(300, style({ opacity: 1 }))]),
      transition('* => void', [style({ opacity: 0 })]),
    ]),
  ],
})
export class HomePageComponent implements OnInit, OnDestroy {
  private readonly isBrowser: boolean = isPlatformBrowser(this.platformId);
  private readonly destroy$ = new Subject<void>();

  selectedTab = TabIndex.FLIGHTS;
  tabIndex = TabIndex;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly homeService: HomeService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly accountsService: AccountsService,
    private readonly dataLayerService: DataLayerService,
    private readonly toolbarService: ToolbarService,
    private readonly tokenService: TokenService,
    private readonly flightSearchService: DestinyService,
    private readonly modalService: NgbModal,
    private readonly configCatService: ConfigCatService
  ) {
    this.setTabFromPath();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.activatedRoute.params.subscribe((product) => {
        this.dataLayerService.sendUserInfo();
        this.dataLayerService.sendVirtualPage(`/confirmacion/${product.tab}`, 'NMV: Confirmacion');
      });

      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => this.setTabFromPath(event.url));

      this.setTabFromFlag();
      this.getConfirmation();
      this.removeStoredFilters();
    }

    this.getToken();
    this.flightSearchService.setOrigin('LIM', 'Lima', 'Perú');
  }

  private getToken() {
    this.tokenService.getAndSaveToken('Chrome').pipe(take(1)).subscribe();
  }

  private setTabFromFlag() {
    this.configCatService.getRedirectToPackagesFlag().then((redirect) => {
      if (!redirect) return;
      this.tabSelectedByUser(TabIndex.PACKAGES);
    });
  }

  tabSelectedByUser(tabIndex: TabIndex) {
    this.selectedTab = tabIndex;
    this.homeService.updateUrlAndSeoByTabIndex(tabIndex);
  }

  private setTabFromPath(url: string = this.router.url) {
    const path = url.replace(/^\/+|\/+$/g, '').trim();
    this.selectedTab = this.homeService.getTabIndexByPath(path);
  }

  private getConfirmation() {
    this.activatedRoute.params
      .pipe(
        filter((params) => params.id),
        switchMap((param) => this.accountsService.confirmationAccount(param.id))
      )
      .subscribe((resp) => {
        if (resp.IsSuccess) {
          this.accountsService.dispatchConfirmate(true);
          this.toggleConfirmationModal();
        }
      });
  }

  private toggleConfirmationModal() {
    const modalRef = this.modalService.open(VerifiedUserComponent, {
      windowClass: 'ModalUsuarioVerificado',
      ariaLabelledBy: 'ModalUsuarioVerificadoLabel',
      backdrop: false,
    });

    modalRef.closed.pipe(take(1)).subscribe(() => {
      this.router.navigateByUrl('/').then(() => null);
      this.toolbarService.openLoginModal();
    });
  }

  /*private showPromoModal() {
    requestAnimationFrame(() => {
      const modalRef = this.modalService.open(PromoImageModalComponent, {
        modalDialogClass: 'promo-modal',
        centered: true,
      });
      modalRef.componentInstance.imageUrl = './assets/img/home/modals/popupnm-arte.webp';
      modalRef.componentInstance.linkUrl = 'https://wa.me/51919294628';
    });
  }*/

  private removeStoredFilters() {
    localStorage.removeItem('filters');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.modalService.dismissAll();
  }
}
